import categoryNameReducer from './category-nameReducer';

export * from './category-nameActions';
export default categoryNameReducer;
